"use client";

import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { track, HOME_EVENTS } from "@/lib/analytics";
import { FAQ_ITEMS } from "@/lib/faq-items";

// Re-export so callers that already import FAQ_ITEMS from this file keep working.
export { FAQ_ITEMS };

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="bg-white py-20 sm:py-28">
      <div className="mx-auto max-w-3xl px-6">
        <div className="mb-12 text-center">
          <p className="ribbon mb-3 text-ink-500">Questions, answered</p>
          <h2 className="font-display text-4xl font-bold tracking-tight text-ink-950 sm:text-5xl text-balance">
            Things people ask before they sign up.
          </h2>
        </div>

        <ul className="divide-y divide-ink-100 border-y border-ink-100">
          {FAQ_ITEMS.map((item, i) => {
            const isOpen = openIndex === i;
            const panelId = `faq-panel-${i}`;
            return (
              <li key={item.question}>
                <button
                  type="button"
                  aria-expanded={isOpen}
                  aria-controls={panelId}
                  onClick={() => {
                    const next = isOpen ? null : i;
                    setOpenIndex(next);
                    if (next !== null) {
                      track(HOME_EVENTS.FAQ_OPEN, {
                        question_id: `faq-${i}`,
                        position: i + 1,
                      });
                    }
                  }}
                  className="flex w-full items-center justify-between gap-6 py-5 text-left"
                >
                  <span className="text-lg font-semibold text-ink-950">
                    {item.question}
                  </span>
                  <ChevronDown
                    aria-hidden="true"
                    className={[
                      "h-5 w-5 shrink-0 text-ink-500 transition-transform",
                      isOpen ? "rotate-180" : "",
                    ].join(" ")}
                  />
                </button>
                <div
                  id={panelId}
                  hidden={!isOpen}
                  className="pb-5 text-ink-600 text-pretty"
                >
                  {item.answer}
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
